class SliderComponent extends HTMLElement {
  constructor() {
    super();

    this.slider_container = this.querySelector(".grid");
    this.slider_item = this.querySelector(".slider__item");
    this.slider_item_width = this.slider_item.offsetWidth;

    // Add click handlers
    this.querySelectorAll(".slider__arrow--back").forEach((arrow) => {
      console.log(arrow)
      arrow.addEventListener("click", () => this.navigate("backward"));
    });
    this.querySelectorAll(".slider__arrow--forward").forEach((arrow) => {
      arrow.addEventListener("click", () => this.navigate("forward"));
    });

    // this.querySelectorAll(".slide-indicator")
    //     .forEach((dot, index) => {
    //         dot.addEventListener("click", () => navigate(index));
    //         dot.addEventListener("mouseenter", () => clearInterval(autoplay));
    //     });

    // Add keyboard handlers
    this.addEventListener("keydown", (e) => {
      if (e.code === "ArrowLeft") {
        // clearInterval(autoplay);
        this.navigate("backward");
      } else if (e.code === "ArrowRight") {
        // clearInterval(autoplay);
        this.navigate("forward");
      }
    });

    // Add resize handler
    window.addEventListener("resize", () => {
      this.slider_item_width = this.slider_item.offsetWidth;
    });

    // Autoplay
    // const autoplay = setInterval(() => navigate("forward"), 3000);
    // slideContainerEl.addEventListener("mouseenter", () => clearInterval(autoplay));

    // this.slideObserver = new IntersectionObserver((entries, observer) => {
    //     entries.forEach(entry => {
    //         if (entry.isIntersecting) {
    //             this.slider_item_index = entry.target.dataset.slideindex;

    //             this.querySelector('.slide-indicator.active').classList.remove('active');
    //             carouselEl.querySelectorAll('.slide-indicator')[slideIndex].classList.add('active');
    //         }
    //     });
    // }, { root: slideContainerEl, threshold: .1 });
    // document.querySelectorAll('.slide').forEach((slide) => {
    //     slideObserver.observe(slide);
    // });
  }

  getNewScrollPosition = (arg) => {
    const gap = +window
        .getComputedStyle(this.slider_container)
        .getPropertyValue("column-gap")
        .slice(0, 2),
      scroll_left = Math.round(this.slider_container.scrollLeft),
      slider_width = Math.round(this.slider_container.clientWidth),
      slider_scroll_width = Math.round(this.slider_container.scrollWidth),
      max_scroll_left = slider_scroll_width - slider_width;

    if (arg === "forward") {
      const x = scroll_left + slider_width;
      return x > max_scroll_left
        ? max_scroll_left - scroll_left < 5
          ? 0
          : max_scroll_left
        : x;
    } else if (arg === "backward") {
      const x = scroll_left - slider_width;
      return x < 0 ? (scroll_left == 0 ? max_scroll_left : 0) : x;
    } else if (typeof arg === "number") {
      const x = arg * (this.slider_item_width + gap);
      return x;
    }
  };
  navigate = (arg) => {
    this.slider_container.scrollLeft = this.getNewScrollPosition(arg);
  };
}
customElements.define("slider-component", SliderComponent);
